module.exports = __webpack_public_path__ + "img/agave_1_1.207c7622.jpg";